import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private oauthService: OAuthService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.oauthService.getAccessToken();
    if (token) {
      const stockBuyerProfile = this.authService.getStockBuyerProfile();

      request = request.clone({
        setHeaders: {
          authorization: `Bearer ${token}`,
          ...(!!stockBuyerProfile && {
            'x-elivestock-buyer-number': `${stockBuyerProfile?.number}`,
          }),
        },
      });
    }
    return next.handle(request);
  }
}
